import { RemoteUpdateFieldAssessments } from 'data/usecases';
import { makeApiUrlFieldAssessments } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteUpdateFieldAssessments =
  (): RemoteUpdateFieldAssessments => {
    return new RemoteUpdateFieldAssessments(
      makeApiUrlFieldAssessments(),
      makeAxiosHttpClient(),
    );
  };
